export default __webpack_public_path__ + "static/media/pause.5d4808d1.svg";